import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material';
import { CategoryForSelectComponent } from './category-for-select/category-for-select.component';
import { LabelSelectComponent } from './label-select.component';

@NgModule({
	declarations: [LabelSelectComponent, CategoryForSelectComponent],
	imports: [CommonModule, MatIconModule],
	exports: [LabelSelectComponent]
})
export class LabelSelectModule {}
